var _rect, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIwm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 107 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 72,
    fill: "#B1A8A8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1182_79154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.056 49.7428H0.0556641V55.2028H106.056V49.7428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 44.2828H0.0556641V49.7428H106.056V44.2828Z",
    fill: "#D20037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 38.8228H0.0556641V44.2828H106.056V38.8228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 55.2028H0.0556641V60.6628H106.056V55.2028Z",
    fill: "#D20037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 66.1328H0.0556641V71.5928H106.056V66.1328Z",
    fill: "#D20037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 60.6728H0.0556641V66.1328H106.056V60.6728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 6.05278H0.0556641V11.5128H106.056V6.05278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 0.592773H0.0556641V6.05277H106.056V0.592773Z",
    fill: "#D20037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 11.5128H0.0556641V16.9728H106.056V11.5128Z",
    fill: "#D20037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 22.4428H0.0556641V27.9028H106.056V22.4428Z",
    fill: "#D20037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 16.9828H0.0556641V22.4428H106.056V16.9828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 27.9028H0.0556641V33.3628H106.056V27.9028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 33.3628H0.0556641V38.8228H106.056V33.3628Z",
    fill: "#D20037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9757 0.592773H0.0556641V38.8228H53.9757V0.592773Z",
    fill: "#002965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54578 2.41278L5.04578 3.94278H6.65578L5.35578 4.89278L5.85578 6.43278L4.54578 5.48278L3.23578 6.43278L3.73578 4.89278L2.42578 3.94278H4.04578L4.54578 2.41278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.486 2.41278L49.986 3.94278H51.596L50.296 4.89278L50.796 6.43278L49.486 5.48278L48.176 6.43278L48.676 4.89278L47.376 3.94278H48.986L49.486 2.41278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4957 2.41278L40.9957 3.94278H42.6157L41.3057 4.89278L41.8057 6.43278L40.4957 5.48278L39.1857 6.43278L39.6857 4.89278L38.3857 3.94278H39.9957L40.4957 2.41278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5055 2.41278L32.0055 3.94278H33.6255L32.3155 4.89278L32.8155 6.43278L31.5055 5.48278L30.2055 6.43278L30.7055 4.89278L29.3955 3.94278H31.0155L31.5055 2.41278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5262 2.41278L23.0262 3.94278H24.6362L23.3263 4.89278L23.8263 6.43278L22.5262 5.48278L21.2162 6.43278L21.7162 4.89278L20.4062 3.94278H22.0262L22.5262 2.41278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.536 2.41278L14.036 3.94278H15.646L14.346 4.89278L14.836 6.43278L13.536 5.48278L12.226 6.43278L12.726 4.89278L11.416 3.94278H13.036L13.536 2.41278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54578 10.0528L5.04578 11.5928H6.65578L5.35578 12.5428L5.85578 14.0728L4.54578 13.1228L3.23578 14.0728L3.73578 12.5428L2.42578 11.5928H4.04578L4.54578 10.0528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.486 10.0528L49.986 11.5928H51.596L50.296 12.5428L50.796 14.0728L49.486 13.1228L48.176 14.0728L48.676 12.5428L47.376 11.5928H48.986L49.486 10.0528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4957 10.0528L40.9957 11.5928H42.6157L41.3057 12.5428L41.8057 14.0728L40.4957 13.1228L39.1857 14.0728L39.6857 12.5428L38.3857 11.5928H39.9957L40.4957 10.0528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5055 10.0528L32.0055 11.5928H33.6255L32.3155 12.5428L32.8155 14.0728L31.5055 13.1228L30.2055 14.0728L30.7055 12.5428L29.3955 11.5928H31.0155L31.5055 10.0528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5262 10.0528L23.0262 11.5928H24.6362L23.3263 12.5428L23.8263 14.0728L22.5262 13.1228L21.2162 14.0728L21.7162 12.5428L20.4062 11.5928H22.0262L22.5262 10.0528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.536 10.0528L14.036 11.5928H15.646L14.346 12.5428L14.836 14.0728L13.536 13.1228L12.226 14.0728L12.726 12.5428L11.416 11.5928H13.036L13.536 10.0528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54578 17.6928L5.04578 19.2328H6.65578L5.35578 20.1828L5.85578 21.7228L4.54578 20.7728L3.23578 21.7228L3.73578 20.1828L2.42578 19.2328H4.04578L4.54578 17.6928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.486 17.6928L49.986 19.2328H51.596L50.296 20.1828L50.796 21.7228L49.486 20.7728L48.176 21.7228L48.676 20.1828L47.376 19.2328H48.986L49.486 17.6928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4957 17.6928L40.9957 19.2328H42.6157L41.3057 20.1828L41.8057 21.7228L40.4957 20.7728L39.1857 21.7228L39.6857 20.1828L38.3857 19.2328H39.9957L40.4957 17.6928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5055 17.6928L32.0055 19.2328H33.6255L32.3155 20.1828L32.8155 21.7228L31.5055 20.7728L30.2055 21.7228L30.7055 20.1828L29.3955 19.2328H31.0155L31.5055 17.6928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5262 17.6928L23.0262 19.2328H24.6362L23.3263 20.1828L23.8263 21.7228L22.5262 20.7728L21.2162 21.7228L21.7162 20.1828L20.4062 19.2328H22.0262L22.5262 17.6928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.536 17.6928L14.036 19.2328H15.646L14.346 20.1828L14.836 21.7228L13.536 20.7728L12.226 21.7228L12.726 20.1828L11.416 19.2328H13.036L13.536 17.6928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54578 25.3428L5.04578 26.8728H6.65578L5.35578 27.8228L5.85578 29.3628L4.54578 28.4128L3.23578 29.3628L3.73578 27.8228L2.42578 26.8728H4.04578L4.54578 25.3428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.486 25.3428L49.986 26.8728H51.596L50.296 27.8228L50.796 29.3628L49.486 28.4128L48.176 29.3628L48.676 27.8228L47.376 26.8728H48.986L49.486 25.3428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4957 25.3428L40.9957 26.8728H42.6157L41.3057 27.8228L41.8057 29.3628L40.4957 28.4128L39.1857 29.3628L39.6857 27.8228L38.3857 26.8728H39.9957L40.4957 25.3428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5055 25.3428L32.0055 26.8728H33.6255L32.3155 27.8228L32.8155 29.3628L31.5055 28.4128L30.2055 29.3628L30.7055 27.8228L29.3955 26.8728H31.0155L31.5055 25.3428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5262 25.3428L23.0262 26.8728H24.6362L23.3263 27.8228L23.8263 29.3628L22.5262 28.4128L21.2162 29.3628L21.7162 27.8228L20.4062 26.8728H22.0262L22.5262 25.3428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.536 25.3428L14.036 26.8728H15.646L14.346 27.8228L14.836 29.3628L13.536 28.4128L12.226 29.3628L12.726 27.8228L11.416 26.8728H13.036L13.536 25.3428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54578 32.9828L5.04578 34.5228H6.65578L5.35578 35.4728L5.85578 37.0028L4.54578 36.0528L3.23578 37.0028L3.73578 35.4728L2.42578 34.5228H4.04578L4.54578 32.9828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.486 32.9828L49.986 34.5228H51.596L50.296 35.4728L50.796 37.0028L49.486 36.0528L48.176 37.0028L48.676 35.4728L47.376 34.5228H48.986L49.486 32.9828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4957 32.9828L40.9957 34.5228H42.6157L41.3057 35.4728L41.8057 37.0028L40.4957 36.0528L39.1857 37.0028L39.6857 35.4728L38.3857 34.5228H39.9957L40.4957 32.9828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5055 32.9828L32.0055 34.5228H33.6255L32.3155 35.4728L32.8155 37.0028L31.5055 36.0528L30.2055 37.0028L30.7055 35.4728L29.3955 34.5228H31.0155L31.5055 32.9828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5262 32.9828L23.0262 34.5228H24.6362L23.3263 35.4728L23.8263 37.0028L22.5262 36.0528L21.2162 37.0028L21.7162 35.4728L20.4062 34.5228H22.0262L22.5262 32.9828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.536 32.9828L14.036 34.5228H15.646L14.346 35.4728L14.836 37.0028L13.536 36.0528L12.226 37.0028L12.726 35.4728L11.416 34.5228H13.036L13.536 32.9828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.996 29.1628L45.496 30.7028H47.106L45.796 31.6528L46.296 33.1828L44.996 32.2328L43.686 33.1828L44.186 31.6528L42.876 30.7028H44.496L44.996 29.1628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0057 29.1628L36.5057 30.7028H38.1157L36.8157 31.6528L37.3157 33.1828L36.0057 32.2328L34.6957 33.1828L35.1957 31.6528L33.8857 30.7028H35.5057L36.0057 29.1628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0155 29.1628L27.5155 30.7028H29.1255L27.8255 31.6528L28.3255 33.1828L27.0155 32.2328L25.7055 33.1828L26.2055 31.6528L24.8955 30.7028H26.5155L27.0155 29.1628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.026 29.1628L18.526 30.7028H20.146L18.836 31.6528L19.336 33.1828L18.026 32.2328L16.716 33.1828L17.216 31.6528L15.916 30.7028H17.526L18.026 29.1628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03578 29.1628L9.53578 30.7028H11.1558L9.84578 31.6528L10.3458 33.1828L9.03578 32.2328L7.73578 33.1828L8.23578 31.6528L6.92578 30.7028H8.54578L9.03578 29.1628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.996 21.5228L45.496 23.0528H47.106L45.796 24.0028L46.296 25.5428L44.996 24.5928L43.686 25.5428L44.186 24.0028L42.876 23.0528H44.496L44.996 21.5228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0057 21.5228L36.5057 23.0528H38.1157L36.8157 24.0028L37.3157 25.5428L36.0057 24.5928L34.6957 25.5428L35.1957 24.0028L33.8857 23.0528H35.5057L36.0057 21.5228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0155 21.5228L27.5155 23.0528H29.1255L27.8255 24.0028L28.3255 25.5428L27.0155 24.5928L25.7055 25.5428L26.2055 24.0028L24.8955 23.0528H26.5155L27.0155 21.5228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.026 21.5228L18.526 23.0528H20.146L18.836 24.0028L19.336 25.5428L18.026 24.5928L16.716 25.5428L17.216 24.0028L15.916 23.0528H17.526L18.026 21.5228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03578 21.5228L9.53578 23.0528H11.1558L9.84578 24.0028L10.3458 25.5428L9.03578 24.5928L7.73578 25.5428L8.23578 24.0028L6.92578 23.0528H8.54578L9.03578 21.5228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.996 13.8728L45.496 15.4128H47.106L45.796 16.3628L46.296 17.9028L44.996 16.9528L43.686 17.9028L44.186 16.3628L42.876 15.4128H44.496L44.996 13.8728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0057 13.8728L36.5057 15.4128H38.1157L36.8157 16.3628L37.3157 17.9028L36.0057 16.9528L34.6957 17.9028L35.1957 16.3628L33.8857 15.4128H35.5057L36.0057 13.8728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0155 13.8728L27.5155 15.4128H29.1255L27.8255 16.3628L28.3255 17.9028L27.0155 16.9528L25.7055 17.9028L26.2055 16.3628L24.8955 15.4128H26.5155L27.0155 13.8728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.026 13.8728L18.526 15.4128H20.146L18.836 16.3628L19.336 17.9028L18.026 16.9528L16.716 17.9028L17.216 16.3628L15.916 15.4128H17.526L18.026 13.8728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03578 13.8728L9.53578 15.4128H11.1558L9.84578 16.3628L10.3458 17.9028L9.03578 16.9528L7.73578 17.9028L8.23578 16.3628L6.92578 15.4128H8.54578L9.03578 13.8728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.996 6.23279L45.496 7.77279H47.106L45.796 8.72279L46.296 10.2528L44.996 9.30279L43.686 10.2528L44.186 8.72279L42.876 7.77279H44.496L44.996 6.23279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0057 6.23279L36.5057 7.77279H38.1157L36.8157 8.72279L37.3157 10.2528L36.0057 9.30279L34.6957 10.2528L35.1957 8.72279L33.8857 7.77279H35.5057L36.0057 6.23279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0155 6.23279L27.5155 7.77279H29.1255L27.8255 8.72279L28.3255 10.2528L27.0155 9.30279L25.7055 10.2528L26.2055 8.72279L24.8955 7.77279H26.5155L27.0155 6.23279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.026 6.23279L18.526 7.77279H20.146L18.836 8.72279L19.336 10.2528L18.026 9.30279L16.716 10.2528L17.216 8.72279L15.916 7.77279H17.526L18.026 6.23279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03578 6.23279L9.53578 7.77279H11.1558L9.84578 8.72279L10.3458 10.2528L9.03578 9.30279L7.73578 10.2528L8.23578 8.72279L6.92578 7.77279H8.54578L9.03578 6.23279Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1182_79154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.0557 61.5928C66.8628 61.5928 78.0557 50.3999 78.0557 36.5928C78.0557 22.7857 66.8628 11.5928 53.0557 11.5928C39.2485 11.5928 28.0557 22.7857 28.0557 36.5928C28.0557 50.3999 39.2485 61.5928 53.0557 61.5928Z",
    fill: "#F38630"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0557 11.5928C39.2508 11.5928 28.0557 22.7879 28.0557 36.5928C28.0557 50.3977 39.2508 61.5928 53.0557 61.5928C66.8605 61.5928 78.0557 50.3977 78.0557 36.5928C78.0557 22.7879 66.8605 11.5928 53.0557 11.5928ZM53.0557 58.2574C41.1105 58.2574 31.391 48.5379 31.391 36.5928C31.391 24.6477 41.1105 14.9281 53.0557 14.9281C65.0008 14.9281 74.7203 24.6477 74.7203 36.5928C74.7203 48.5379 65.0008 58.2574 53.0557 58.2574Z",
    fill: "#FDC400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0553 55.7574C63.6396 55.7574 72.2199 47.1771 72.2199 36.5928C72.2199 26.0084 63.6396 17.4281 53.0553 17.4281C42.4709 17.4281 33.8906 26.0084 33.8906 36.5928C33.8906 47.1771 42.4709 55.7574 53.0553 55.7574Z",
    fill: "#FDC400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5559 34.8794V28.5257C55.7754 28.9281 56.6961 29.794 56.9705 30.855C57.0681 31.233 57.3791 31.5135 57.7693 31.5135H60.1535C60.6596 31.5135 61.062 31.0623 60.9827 30.5623C60.5132 27.6233 57.8974 25.2757 54.5559 24.7208V22.422C54.5559 21.9647 54.1839 21.5867 53.7205 21.5867H52.3852C51.9279 21.5867 51.5498 21.9586 51.5498 22.422V24.7208C47.8547 25.3306 45.0498 28.1355 45.0498 31.5074C45.0498 34.8794 47.8547 37.6842 51.5498 38.294V44.6476C50.3303 44.2452 49.4096 43.3794 49.1352 42.3184C49.0376 41.9403 48.7266 41.6598 48.3364 41.6598H45.9522C45.4461 41.6598 45.0437 42.1111 45.123 42.6111C45.5925 45.5501 48.2083 47.8976 51.5498 48.4525V50.7513C51.5498 51.2086 51.9218 51.5867 52.3852 51.5867H53.7205C54.1779 51.5867 54.5559 51.2147 54.5559 50.7513V48.4525C58.251 47.8428 61.0559 45.0379 61.0559 41.6659C61.0559 38.294 58.251 35.4891 54.5559 34.8794ZM49.0559 31.5135C49.0559 30.1598 50.0925 29.0074 51.5559 28.5257V34.5013C50.0925 34.0196 49.0559 32.8672 49.0559 31.5135ZM54.5559 44.6537V38.6781C56.0193 39.1598 57.0559 40.3123 57.0559 41.6659C57.0559 43.0196 56.0193 44.172 54.5559 44.6537Z",
    fill: "#F38630"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1182_79154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 71,
    fill: "white",
    transform: "translate(0.0556641 0.592773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1182_79154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(28.0557 11.5928)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIwm);
export default __webpack_public_path__ + "static/media/IWM.cef05eee3bd2941912bf24d9cd2a6abb.svg";
export { ForwardRef as ReactComponent };